// extracted by mini-css-extract-plugin
export var button = "hero-module--button--pWZB0";
export var heading = "hero-module--heading--T2XhL";
export var hero = "hero-module--hero--dS6ix";
export var img = "hero-module--img--k3ivo";
export var inside = "hero-module--inside--9Xk6J";
export var people = "hero-module--people--XAUZq";